import React, { useContext, useState } from "react";
import { collection, query, where, getDocs,getDoc, setDoc, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { AuthContext } from "../context/AuthContext";
import search from "../im/search.png";


const Search=()=>{
    const [username,setUsername]=useState("");
    const [usern,setUsern]=useState("");
    const [useri,setUseri]=useState("");
    const [err,setErr]=useState(false);
    const {currentUser}=useContext(AuthContext);
    const [useruid,setUseruid]=useState("");
    const handleSearch=async()=>{
        const q=query(
        collection(db,"users"),
        where("displayName","==",username));
        try{
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {setUsern(doc._document.data.value.mapValue.fields.displayName.stringValue);
                setUseri(doc._document.data.value.mapValue.fields.photoURL.stringValue);
                setUseruid(doc._document.data.value.mapValue.fields.uid.stringValue);
                
});
        }catch(error){
            setErr(true);
            console.log(error);
        }
        
    }
    const handleKey=(e)=>{
        handleSearch();
    };
    const combuid=currentUser.uid>useruid?currentUser.uid+useruid:useruid+currentUser.uid;
    const handleSelect=async()=>{
        const combuid=currentUser.uid>useruid?currentUser.uid+useruid:useruid+currentUser.uid;
        try{
            const res=await getDoc(doc(db,"chats",combuid));
            if(!res.exists()){
                await setDoc(doc(db,"chats",combuid),{messages:[]});
                await updateDoc(doc(db,"userchats",currentUser.uid),{
                    [combuid+".userInfo"]:{
                        uid:useruid,
                        displayName:usern,
                        photoURL:useri,
                    },
                    [combuid+".date"]:serverTimestamp()
                });
                await updateDoc(doc(db,"userchats",useruid),{
                    [combuid+".userInfo"]:{
                        uid:currentUser.uid,
                        displayName:currentUser.displayName,
                        photoURL:currentUser.photoURL,
                    },
                    [combuid+".date"]:serverTimestamp()
                });
                
            };
               
        }catch(err){
            console.log(err);
            alert(err);

        }
        setUsername("");
        setUseri("");
        setUsern("");
        setUseruid("");
        

    }

    return(
        <div className="Search">
            <div className="SearchForm">
                <input type="text" placeholder="Search User"  onChange={(e)=>setUsername(e.target.value)} value={username}/>
                <button  onClick={handleKey}>
                    Search</button>
            </div>
            {err && <span>User not Found</span>};
            {usern &&<div className="UserChat" onClick={()=>handleSelect()}>
                <img src={useri} alt="" />
                <div className="UserChatInfo">
                    <span>{usern}</span>


                </div>
            </div>}
        </div>
    )
}

export default Search